import { useState } from "react"

export const useSkinQuizResults = (userInput) => {
    const [functionObject, setFunctionObject] = useState({
          
        })
    return [functionObject, setFunctionObject]
}
